// Angular imports
import { HttpErrorResponse } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';

// 3rd party imports
import { alert } from 'devextreme/ui/dialog';
import { SentryErrorHandler } from '@sentry/angular';

// Service imports
import { ClientErrorService } from '../_services/shared-services/client-error.service';
import { ServerErrorService } from '../_services/shared-services/server-error.service';

@Injectable()
export class MPErrorsHandler extends SentryErrorHandler {
    constructor(private readonly injector: Injector) {
        // Call the SentryErrorHandler constructor
        super({
            showDialog: false // This configures the user feedback dialog and crash report modal
        });
    }

    handleError(error: Error | HttpErrorResponse) {
        // Sentry errors are captured within serverErrorService.displayError()

        const clientErrorService = this.injector.get(ClientErrorService);
        const serverErrorService = this.injector.get(ServerErrorService);

        if (error instanceof HttpErrorResponse) {
            // Server or connection error
            serverErrorService.displayError(error);
        } else {
            // Client Error (Angular Error, ReferenceError...)
            clientErrorService.displayError(error);
            if (error.message.includes('this._contentReadyAction is not a function')) {
                alert(
                    `An internal error occurred with this view. Please reload / refresh your browser window to fix this error`,
                    'View Error'
                );
            }
        }

        // Log error to console
        console.error(error);
    }
}
